import { moveItemInArray } from "@angular/cdk/drag-drop";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { ModalDismissReasons, NgbDateStruct, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";
import { DateUtilsService } from "src/app/_services/dateUtils";
import { InvoiceService } from "./../../../_services/invoice.service";

@Component({
  selector: "app-upload-preview-nonpo-digital-invoice",
  templateUrl: "./upload-preview-nonpo-digital-invoice.component.html",
  styleUrls: ["./upload-preview-nonpo-digital-invoice.component.scss"],
})
export class UploadPreviewNonpoDigitalInvoiceComponent implements OnInit, DirtyCheckComponent {
  docs = [
    {
      docType: "NO1X",
      description: "NO1X",
    },
    {
      docType: "NO1G",
      description: "NO1G",
    },
  ];

  invoiceDetails: any;
  invoiceType: any;
  closeResult: string = "";
  modalOptions: NgbModalOptions;
  loading: boolean = false;
  invoiceSaved: boolean = false;
  uploadInvoice: boolean = false;
  uploadSuccessful: boolean = false;
  saving: boolean = false;
  displayName: any;
  hasError = false;
  safeUrl: SafeResourceUrl = "";
  pdfSrc: any;
  fileLink: any;
  fileSizeError = false;
  fileTypeError = false;
  typeError = false;
  sizeError = false;
  supportingDocuments: any[] = [];
  agreed = [{ status: false }];
  invoiceFile: any;
  invoiceDataToSave: any;
  isInvoiceChange: boolean = false;
  isUpdatedData: boolean = false;
  invoiceChanged: boolean = false;
  responseData: any;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  barcodeNo: any;
  eInvoice = false;
  reqData: any;
  formData: any;
  DocDt: NgbDateStruct;
  model: NgbDateStruct;
  irnExist: boolean = false;
  dsLoaderMsg = "";
  formSubmitted = false;
  previousUrl: any;
  companies: any;
  organisations: any;
  configResCompanies: any;
  configResOrg: any;
  totalSizeError = false;
  files: File[];
  supportingDocsAdded = false;
  canSubmitForm = false;
  allDeleted = false;
  invalidDate = false;
  dateError = false;
  isError = false;
  vendorData: any;
  masterData: any;
  savingError = false;
  validationError = false;
  serverError = false;

  digitalInvoice = new FormGroup({
    SellerGstin: new FormControl("", [Validators.required, Validators.minLength(15), Validators.maxLength(15)]),
    file_link: new FormControl(""),
    BuyerGstin: new FormControl(""),
    DocNo: new FormControl("", [Validators.required]),
    DocTyp: new FormControl(""),
    DocDt: new FormControl("", [Validators.required]),
    TotInvVal: new FormControl(null, [Validators.required, Validators.pattern("^([0-9]+(.?[0-9]?[0-9]?)?)")]),
    ItemCnt: new FormControl(""),
    Irn: new FormControl("", [Validators.minLength(64), Validators.maxLength(64)]),
    IrnDt: new FormControl(""),
    MainHsnCode: new FormControl(""),
    file: new FormControl(""),
    supportingFiles: new FormControl([]),
    fileSource: new FormControl(""),
    documentSource: new FormControl(""),
    terms_agreed: new FormControl(false),
    emailAddress: new FormControl("", [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
    username: new FormControl(""),
    userID: new FormControl(""),
    companyCode: new FormControl("", [Validators.required]),
    purchaseOrg: new FormControl("", [Validators.required]),
    docType: new FormControl("", [Validators.required]),
  });
  error: any;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private invoiceService: InvoiceService,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private dateUtils: DateUtilsService
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      scrollable: true,
    };

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.previousUrl = val.url;
      }
    });
  }

  setAsDirty() {
    this.digitalInvoice.controls["Irn"].markAsDirty;
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  selectDocuments(event: any) {
    const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB
    const MAX_TOTAL_SIZE = 100 * 1024 * 1024; // 100MB
    const ALLOWED_TYPES = ["application/pdf"];

    this.files = Array.from(event);
    // Calculate the total size of the selected files (in bytes)
    const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

    // Check if the total size exceeds 100 MB
    if (totalSize > MAX_TOTAL_SIZE) {
      this.totalSizeError = true;
      this.sizeError = false;
      this.typeError = false;
    }

    for (const file of this.files) {
      // Check if any individual file size exceeds 25 MB
      if (file.size > MAX_FILE_SIZE) {
        this.sizeError = true;
        this.typeError = false;
        this.totalSizeError = false;
        continue;
      }

      // Filter out any files that are not PDF
      if (!ALLOWED_TYPES.includes(file.type)) {
        this.typeError = true;
        this.sizeError = false;
        this.totalSizeError = false;
        continue;
      }
      this.supportingDocuments.push(file);
    }

    if (this.allDeleted === true) {
      if (this.digitalInvoice.get("terms_agreed").value === true) {
        this.digitalInvoice.patchValue({
          terms_agreed: false,
        });
      }
    } else {
      this.digitalInvoice.patchValue({ terms_agreed: false });
    }

    this.supportingDocsAdded = true;
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.supportingDocuments.splice(index, 1);

    if (this.supportingDocuments.length === 0) {
      if (this.digitalInvoice.get("terms_agreed").value === true) {
        this.digitalInvoice.patchValue({
          terms_agreed: false,
        });
      }

      this.canSubmitForm = false;
      this.allDeleted = true;
      this.supportingDocsAdded = false;
    }
  }

  checkSupportingDocuments() {
    if (this.supportingDocuments.length > 0 && this.digitalInvoice.get("terms_agreed").value === false && !this.invalidDate) {
      this.canSubmitForm = true;
    } else {
      this.canSubmitForm = false;
    }
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.previousUrl = this.route.snapshot.queryParams["returnUrl"] || "dashboard";
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  onDrop(event: any) {
    // Update the list order
    moveItemInArray(this.supportingDocuments, event.previousIndex, event.currentIndex);
    this.supportingDocsAdded = true;
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  reUploadInvoice(event: any) {
    if (event.length > 0) {
      const fileUploaded = event[0];

      if (fileUploaded.type !== "application/pdf") {
        this.hasError = false;
        this.fileSizeError = false;
        this.fileTypeError = true;
      } else if (fileUploaded.size > 100 * 1024 * 1024) {
        this.fileTypeError = false;
        this.hasError = false;
        this.fileSizeError = true;
      } else {
        this.fileSizeError = false;
        this.fileTypeError = false;

        if (typeof FileReader !== "undefined") {
          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
          };
          let $file: any = fileUploaded;
          reader.readAsArrayBuffer($file);
        }

        this.digitalInvoice.patchValue({
          fileSource: fileUploaded,
        });

        this.hasError = false;
        this.isInvoiceChange = true;
        this.loading = true;
        this.formSubmitted = true;
        this.invoiceChanged = true;

        // Create ledger array similar to digital signature verification for non-PO
        const ledger: any[] = [
          {
            docType: "APINV",
            docDetail: {
              docFormat: "ds-invoice",
              docCat: "non_po_based",
            },
            cmpCode: this.digitalInvoice.value.companyCode || "",
            purchaseOrg: this.digitalInvoice.value.purchaseOrg || "",
            erpDocType: this.digitalInvoice.value.docType || "",
          },
        ];

        const formData: any = new FormData();
        formData.append("sellerCode", localStorage.getItem("sellerCode"));
        formData.append("ledger", JSON.stringify(ledger));
        formData.append("invoiceFile", this.digitalInvoice.value.fileSource);
        formData.append("supplierCode", localStorage.getItem("vendorCode"));
        formData.append("docNo", this.digitalInvoice.value.DocNo || "");

        this.dsLoaderMsg = "Verifying Signature";

        setTimeout(() => {
          this.dsLoaderMsg = "Authenticating Signature";
        }, 5000);
        setTimeout(() => {
          this.dsLoaderMsg = "Extracting Data";
        }, 10000);
        setTimeout(() => {
          this.dsLoaderMsg = "Validating Data";
        }, 15000);

        this.invoiceService.verifyDigitalSignature(formData).subscribe(
          (res) => {
            this.loading = false;
            this.formSubmitted = false;
            this.invoiceChanged = false;
            this.responseData = res;
            if (this.responseData.length !== 0 && this.responseData.status === "error") {
              this.hasError = true;
            } else {
              this.formData = this.responseData.data;
              if (typeof this.formData.irn !== "undefined") {
                this.irnExist = true;
              } else {
                this.irnExist = false;
              }
              let dDate;
              if (typeof this.formData.invoiceDate !== "undefined") {
                const docDtFormControl = this.digitalInvoice.controls["DocDt"] as FormControl;
                docDtFormControl.valueChanges.subscribe((newDate) => {
                  this.checkAndUpdateDateValidity(newDate);
                });
                dDate = this.formData.invoiceDate.replaceAll(".", "/");
              } else {
                dDate = "";
              }
              this.digitalInvoice.patchValue({
                SellerGstin: this.formData.vendorGSTIN,
                DocNo: this.formData.invoiceNumber,
                DocDt: this.formData.invoiceDate.replaceAll(".", "/"),
                TotInvVal: this.formData.invoiceAmount,
                Irn: this.formData.irn,
              });
              this.fileLink = this.responseData.file_link;
              this.hasError = false;
            }
          },
          (error) => {
            console.error(error.msg);
          }
        );
      }
    }
  }

  onSubmitDigitalInvoice() {
    this.loading = true;
    this.uploadInvoice = true;
    this.formSubmitted = true;
    this.hasError = false;

    let username = this.invoiceService.getUsername();
    let userID = this.invoiceService.getUserId();

    const userData = {
      companyCode: this.digitalInvoice.value.companyCode,
      purchaseOrg: this.digitalInvoice.value.purchaseOrg,
      docType: this.digitalInvoice.value.docType,
      emailAddress: this.digitalInvoice.value.emailAddress,
      poNo: "",
      username: username,
      userId: userID,
      items: [{ poNo: "", itemNo: "", grn: "" }],
      termsAgreed: true,
    };

    if (this.isInvoiceChange === true) {
      this.invoiceFile = this.digitalInvoice.value.fileSource;
    } else {
      this.invoiceFile = this.invoiceService.getFileElement();
    }

    const trimNo = this.digitalInvoice.value.DocNo.replace(/\s+/g, "");

    const mapKeys = {
      file_link: this.fileLink,
      SellerGstin: this.digitalInvoice.value.SellerGstin,
      BuyerGstin: "",
      DocNo: trimNo,
      DocTyp: "INV",
      DocDt: this.digitalInvoice.value.DocDt,
      TotInvVal: this.digitalInvoice.value.TotInvVal,
      ItemCnt: "",
      MainHsnCode: "",
      Irn: this.digitalInvoice.value.Irn,
      IrnDt: "",
      invType: this.invoiceService.getInvType(),
      invoiceType: this.invoiceService.getInvoiceType(),
    };

    const fileOrder = [];
    this.supportingDocuments.forEach((file, index) => {
      const obj = {};
      obj[(index + 1).toString()] = file.name;
      fileOrder.push(obj);
    });

    // Get current user session data
    const currentUser = this.authService.getCurrentUser();

    const session = currentUser.eippSessionData.data.session;

    // Create ledger structure similar to digital invoice
    const timestamp = Date.now;
    const ledger = [
      {
        docDate: this.dateUtils.formatDateString(this.digitalInvoice.value.DocDt),
        dueDate: this.dateUtils.formatDateString(this.digitalInvoice.value.DocDt),
        dueAmt: parseFloat(this.digitalInvoice.value.TotInvVal),
        docAmt: parseFloat(this.digitalInvoice.value.TotInvVal),
        docType: "APINV",
        poNo: "",
        docNo: trimNo,
        timestamp: timestamp,
        currCode: "INR",
        status: "PENDING_SUBMISSION",
        supplierNm: localStorage.getItem("displayName"),
        docDetail: {
          docAmt: this.digitalInvoice.value.TotInvVal,
          docFormat: "ds-invoice",
          docCat: "non_po_based",
          docGstin: this.digitalInvoice.value.SellerGstin,
          irn: this.digitalInvoice.value.Irn,
          barcodePrefix: this.invoiceDetails.barcodePrefix,
        },
        docRef: [
          {
            src: this.invoiceDetails.src || "",
          },
        ],
        lineItemDetail: [
          // {
          //   poLineNo: "",
          //   grn: "",
          //   grnNo: trimNo,
          // },
        ],
        supplierCode: localStorage.getItem("vendorCode"),
        cmpCode: this.digitalInvoice.value.companyCode,
        purchaseOrg: this.digitalInvoice.value.purchaseOrg,
        erpDocType: this.digitalInvoice.value.docType,
        email: this.digitalInvoice.value.emailAddress,
      },
    ];

    const formData: any = new FormData();
    formData.append("sellerCode", this.authService.getSellerCode());
    formData.append("reqType", "payexap");
    formData.append("session", JSON.stringify(session));
    formData.append("action", "add");
    formData.append("ledger", JSON.stringify(ledger));

    if (this.supportingDocuments.length !== 0) {
      for (let i = 0; i < this.supportingDocuments.length; i++) {
        formData.append("supportingDocs", this.supportingDocuments[i]);
      }
    } else {
      formData.append("supportingDocs", this.supportingDocuments);
    }

    if (!this.saving) {
      this.invoiceService.uploadInvoiceWithoutExtration(formData).subscribe(
        (res) => {
          this.responseData = res;
          if (this.responseData.status === "error") {
            this.loading = false;
            this.uploadInvoice = false;
            this.hasError = true;
            this.formSubmitted = false;
          } else {
            this.barcodeNo = this.responseData.barcode;
            this.uploadSuccessful = true;
            this.uploadInvoice = false;
          }
        },
        (error) => {
          console.error(error);
          this.loading = false;
          this.error = error.error.message;
          this.uploadInvoice = false;
          this.uploadSuccessful = false;
          this.invoiceSaved = false;
          this.serverError = true;
        }
      );
    }

    this.modalService.dismissAll();
  }

  fetchPurchaseOrg() {
    const configReq = {
      type: "purchaseOrganizations",
    };

    this.invoiceService.getConfig(configReq).subscribe(
      (res) => {
        this.configResOrg = res;
        if (this.configResOrg.length !== 0 && this.configResOrg.status === "error") {
          console.error(this.configResOrg + " Error");
        } else {
          this.organisations = this.configResOrg.data;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  fetchCompanyCode() {
    const configReq = {
      type: "companyCodes",
    };

    this.invoiceService.getConfig(configReq).subscribe(
      (res) => {
        this.configResCompanies = res;
        if (this.configResCompanies.length !== 0 && this.configResCompanies.status === "error") {
          console.error(this.configResCompanies + " Error");
        } else {
          this.companies = this.configResCompanies.data;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.invoiceDetails = this.invoiceService.getDataDigitalInvoice();

    this.loadFile();
    this.formSubmitted = false;

    this.fileLink = this.invoiceService.fileUrl;
    this.reqData = this.invoiceService.getNonPOFields();

    this.formData = this.invoiceService.getDataDigitalInvoice();

    if (typeof this.formData.irn !== "undefined") {
      this.irnExist = true;
    }

    this.fetchCompanyCode();
    this.fetchPurchaseOrg();

    let documentDate;
    if (typeof this.formData.invoice_date !== "undefined") {
      const docDtFormControl = this.digitalInvoice.controls["DocDt"] as FormControl;
      docDtFormControl.valueChanges.subscribe((newDate) => {
        this.checkAndUpdateDateValidity(newDate);
      });
      documentDate = this.formData.invoice_date.replaceAll(".", "/");
    } else {
      documentDate = "";
    }

    this.digitalInvoice.patchValue({
      SellerGstin: this.formData.gstin,
      DocNo: this.formData.invoice_number,
      DocDt: documentDate,
      TotInvVal: this.formData.invoice_amount,
      Irn: this.formData.irn,
      companyCode: this.invoiceDetails.cmpCode,
      purchaseOrg: this.invoiceDetails.purchaseOrg,
      docType: this.invoiceDetails.erpDocType,
      username: this.invoiceService.getUsername(),
      userID: this.invoiceService.getUserId(),
      emailAddress: this.invoiceDetails.email_address.toLowerCase(),
    });

    this.setAsDirty();
  }

  ngAfterViewInit(): void {
    // Subscribe to changes of the DocDt FormControl after initialization
    const docDtFormControl = this.digitalInvoice.get("DocDt") as FormControl;

    docDtFormControl.valueChanges.subscribe((newDate) => {
      this.checkAndUpdateDateValidity(newDate);
    });
  }

  checkAndUpdateDateValidity(newDate) {
    if (!this.isDateValid(newDate)) {
      this.invalidDate = true;
      this.dateError = true;
    } else {
      if (this.digitalInvoice.get("terms_agreed").value === true) {
        this.digitalInvoice.patchValue({ terms_agreed: false });
      }
      this.invalidDate = false;
      this.dateError = false;
    }
  }

  isDateValid(dateString: string): boolean {
    const dateParts = dateString.split(/[./]/); // Split using either "." or "/"

    if (dateParts.length !== 3) {
      return false;
    }

    const day = Number(dateParts[0]);
    const month = Number(dateParts[1]);
    const year = Number(dateParts[2]);

    const currentYear = new Date().getFullYear();

    // Check if day is within the range of 1 to 31 and not NaN
    if (isNaN(day) || day < 1 || day > 31) {
      return false;
    }

    // Check if month is within the range of 1 to 12 and not NaN
    if (isNaN(month) || month < 1 || month > 12) {
      return false;
    }

    // Check if year is within the range of 2000 to current year and not NaN
    if (isNaN(year) || year < 2000 || year > currentYear) {
      return false;
    }

    return true;
  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/invoices");
  }

  closeErrorDialog() {
    this.loading = false;
    this.savingError = false;
    this.serverError = false;
  }

  resubmitInvoice() {
    const poNo = this.route.snapshot.params["poNo"];
    this.router.navigate(["/submit-invoice", poNo]);
  }

  loadFile() {
    if (typeof FileReader !== "undefined") {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
      };
      let $file: any = this.invoiceService.getFileElement();
      reader.readAsArrayBuffer($file);
    }
  }

  onCheckboxChange(e: any) {
    if (e.target.checked) {
      this.digitalInvoice.patchValue({
        terms_agreed: e.target.value,
      });
    } else {
      this.digitalInvoice.patchValue({
        terms_agreed: null,
      });
    }
  }

  viewSavedInvoices() {
    this.router.navigate(["/saved-invoices"]);
  }
}
